import { productsMock } from './productsMock'

export const similarItemsAreaMock = {
  products: productsMock,
}
